import * as React from 'react';
export const quickbooksSvg = React.forwardRef(function quickbooksSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#2CA01C',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4 15.89a6.46 6.46 0 0 0 6.46 6.46h.925v-2.398h-.924a4.066 4.066 0 0 1-4.06-4.063 4.065 4.065 0 0 1 4.06-4.06h2.218v12.552a2.4 2.4 0 0 0 2.4 2.4V9.43H10.46A6.46 6.46 0 0 0 4 15.89Zm17.54-6.46h-.922v2.4h.923a4.066 4.066 0 0 1 4.06 4.06 4.066 4.066 0 0 1-4.06 4.063h-2.22V7.399A2.4 2.4 0 0 0 16.921 5v17.351h4.618A6.46 6.46 0 0 0 21.54 9.43Z',
      fill: '#fff',
    }),
  );
});
quickbooksSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var quickbooks = {
  category: 'brand',
  colorable: false,
  name: 'quickbooks',
  svg: quickbooksSvg,
};
